import config from '@/config'
import { UserRoles } from '@/models/Users'
import { useGlobalStore } from '@/store/app'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

const http = requests(config?.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('locationId')
class GlobalProfileServiceCls {
  constructor() {}
  get endpoint(): string {
    const appStore = useGlobalStore()
    return `/${appStore.locationId}/users`
  }
  async getGlobalUserProfile(userSlug: string) {
    const response = await http.get(`${this.endpoint}/slug/${userSlug}`)
    return response.data
  }
  async getCommonGroups(contactId: string) {
    const response = await http.get(
      `${this.endpoint}/${contactId}/common-groups`
    )
    return response.data
  }

  async getUserGroups({
    contactId,
    role,
  }: {
    contactId: string
    role?: UserRoles
  }) {
    const response = await http.get(`${this.endpoint}/${contactId}/groups`, {
      params: {
        role,
      },
    })
    return response.data
  }

  async getUserAccessibleGroups(contactId: string) {
    const response = await http.get(
      `${this.endpoint}/${contactId}/accessible-groups`
    )
    return response.data
  }
}

// Export singleton instance
export const GlobalProfileService = new GlobalProfileServiceCls()

// Export type for dependency injection
export type IGlobalProfileService = GlobalProfileServiceCls

// Export commonly used methods directly
export const { getGlobalUserProfile } = GlobalProfileService
